import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen bg-[#FAF9F7] font-sans selection:bg-[#800000] selection:text-white flex flex-col" data-id="element-193">
      <Navbar data-id="element-194" />
      <main className="flex-grow pt-28" data-id="element-195">{children}</main>
      <Footer data-id="element-196" />
    </div>;
}